import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterViewIndex from '@/views/RouterViewIndex.vue';
import i18n from '@/i18n/index.js';
Vue.use(VueRouter);

export default [
  {
    path: 'personal',
    name: 'personal-index',
    component: RouterViewIndex,
    query: {
      state: 'exam',
    },
    redirect: {
      name: 'personal',
      query: {
        state: 'exam',
      },
    },
    meta: {
      key: 'personal',
      title: i18n.t('個人資訊'),
      requireAuth: true,
      requireMobile: true,
    },
    children: [
      {
        path: '',
        name: 'personal',
        component: () => import('@/views/Personal/Personal.vue'),
      },
      {
        path: 'transcript/:examId?',
        name: 'transcript',
        component: () => import('@/views/Personal/Transcript.vue'),
        meta: {
          title: i18n.t('棋力檢定結果'),
        },
      },
      {
        path: 'apply-certificate/:certificationId',
        name: 'apply-certificate',
        component: () => import('@/views/Personal/ApplyCertificate.vue'),
        meta: {
          title: i18n.t('申請證書'),
        },
      },
      {
        path: 'registration-detail/:orderId',
        name: 'registration-detail-index',
        component: RouterViewIndex,
        redirect: {
          name: 'registration-detail',
        },
        children: [
          {
            path: '',
            name: 'registration-detail',
            component: () => import('@/views/Personal/RegistrationDetail.vue'),
            meta: {
              title: i18n.t('詳細資訊'),
            },
          },
        ],
      },
      {
        path: 'exam-waiting',
        name: 'exam-waiting-index',
        component: RouterViewIndex,
        redirect: {
          name: 'exam-waiting',
        },
        children: [
          {
            path: '',
            name: 'exam-waiting',
            component: () => import('@/components/Personal/ExamWaiting.vue'),
            meta: {
              title: i18n.t('棋力檢定開始畫面'),
            },
          },
        ],
      },
      {
        path: 'apply-certificate/:certificationId/result/:paymentId',
        name: 'apply-certificate-result',
        component: () => import('@/views/Personal/ApplyCertificateResult.vue'),
        meta: {
          title: i18n.t('申請證書'),
        },
      },
    ],
  },
  {
    path: 'setting',
    name: 'setting-index',
    component: RouterViewIndex,
    query: {
      state: 'info',
    },
    redirect: {
      name: 'setting',
      query: {
        state: 'info',
      },
    },
    children: [
      {
        path: '',
        name: 'setting',
        component: () => import('@/views/Personal/Setting.vue'),
        meta: {
          title: i18n.t('設定'),
          requireAuth: true,
        },
        children: [
          {
            path: 'rank-setting',
            name: 'rank-setting',
            component: () => import('@/views/Personal/RankSetting.vue'),
            meta: {
              title: i18n.t('上傳其它協會證書'),
              requireAuth: true,
            },
          },
        ],
      },
    ],
  },
];
